import { request } from '@/common/services/request';
import type { AccountBalance } from '@/types/api';

export type { AccountBalance };

/** GET /v1/account — WATT trading balance */
export const getAccount = (): Promise<AccountBalance> => {
  return request({
    url: '/v1/account',
    method: 'GET',
  });
};
